const UNCHANGED = 'oförändrad';
(function () {
    // Hamburger Toggle Menu

    const DIAGRAM_TREND_DIRECTION_CLASS = 'statistics-group__section__diagram__trend-direction';

    const hamburger = {
        navToggle: document.querySelector('.nav-toggle'),
        nav: document.querySelector('nav'),

        doToggle: function (e) {
            e.preventDefault();
            this.navToggle.classList.toggle('expanded');
            this.nav.classList.toggle('expanded');
        }
    };

    const sap = {
        ui: {
            keycodes: {
                SPACE: 32,
                ENTER: 13,
                ESC: 27
            }
        }
    };

    if (hamburger.navToggle) {
        hamburger.navToggle.addEventListener('click', function (e) {
            hamburger.doToggle(e);
        });

        hamburger.navToggle.addEventListener('keydown', function (e) {
            if (e.keyCode == sap.ui.keycodes.ENTER) {
                hamburger.doToggle(e);
            }
        });
    }

    const bodyclass = document.querySelector('body');
    bodyclass.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            $('.nav-toggle').removeClass('expanded');
            $('.main-nav').removeClass('expanded');
            $('.subMenuBtn').removeClass('open');
            $('.subMenu').removeClass('open');
        }
    });


    const twitterLinks = document.querySelectorAll('.twitter-link');
    if (twitterLinks) {
        for (var i = 0; i < twitterLinks.length; i++) {
            var link = twitterLinks[i];
            link.addEventListener('click', navigateLink);
            link.addEventListener('keyup', navigateLink);
        }
    }


    // Checks if the carousel exists
    if (document.getElementById('carousel') != null) {

        const carousel = document.getElementById('carousel');
        const slides = carousel.querySelectorAll('.slide');
        const indicators = carousel.querySelectorAll('.indicator');
        const switcher = 0;
        const speed = 12000;

        function carouselHide(num) {
            indicators[num].setAttribute('data-state', '');
            slides[num].setAttribute('data-state', '');
            slides[num].style.opacity = 0;
        }

        function carouselShow(num) {
            indicators[num].checked = true;
            indicators[num].setAttribute('data-state', 'active');
            slides[num].setAttribute('data-state', 'active');
            slides[num].style.opacity = 1;
        }

        function setSlide(slide) {
            return function () {
                // Reset all slides
                for (var i = 0; i < indicators.length; i++) {
                    indicators[i].setAttribute('data-state', '');
                    slides[i].setAttribute('data-state', '');
                    carouselHide(i);
                }
                // Set defined slide as active
                indicators[slide].setAttribute('data-state', 'active');
                slides[slide].setAttribute('data-state', 'active');
                carouselShow(slide);
                // Stop the auto-switcher
                clearInterval(switcher);
            };
        }

        function switchSlide() {
            let nextSlide = 0;
            // Reset all slides
            for (var i = 0; i < indicators.length; i++) {
                // If current slide is active & NOT equal to last slide then increment nextSlide
                if ((indicators[i].getAttribute('data-state') == 'active') && (i !== (indicators.length - 1))) {
                    nextSlide = i + 1;
                }
                // Remove all active states & hide
                carouselHide(i);
            }
            // Set next slide as active & show the next slide
            carouselShow(nextSlide);
        }

        if (carousel) {
            const slides = carousel.querySelectorAll('.slide');
            const indicators = carousel.querySelectorAll('.indicator');
            if (slides.length > 1) {
                const switcher = setInterval(function () {
                    switchSlide();
                }, speed);
            }
            for (var i = 0; i < indicators.length; i++) {
                indicators[i].addEventListener("click", setSlide(i));
            }
            if (indicators.length < 2) {
                for (var i = 0; i < indicators.length; i++) {
                    indicators[i].style.display = 'none';
                }
            }
        }
    }

    // Desktop Search Icon
    const searchIcons = document.querySelectorAll('.desktop-search-icon, .device-search-icon');
    const desktopSearchForm = document.querySelector('.desktop-search-form');

    let assetsPath = '';
    if (searchIcons && searchIcons.length > 0) {
        assetsPath = searchIcons[0].getAttribute('data-assets-path');
    }

    searchIcons.forEach(searchItem => {
        searchItem.addEventListener('click', () => {

            if (desktopSearchForm.classList.contains('open')) {
                desktopSearchForm.classList.remove('open');
                searchItem.setAttribute('src', assetsPath + 'images/search-icon.svg');
            } else {
                desktopSearchForm.classList.add('open');
                searchItem.setAttribute('src', assetsPath + 'images/close.svg');
            }
        });

        // Desktop search icon listen to enter-click
        searchItem.addEventListener('keyup', function (e) {
            if (e.keyCode === 13) {
                if (desktopSearchForm.classList.contains('open')) {
                    desktopSearchForm.classList.remove('open');
                    searchItem.setAttribute('src', assetsPath + 'images/search-icon.svg');
                } else {
                    desktopSearchForm.classList.add('open');
                    searchItem.setAttribute('src', assetsPath + 'images/close.svg');
                }
            }
        });
    });


    // Checks if the Mobile Sub Menu exists
    if (document.querySelector('.subMenuBtn') != null) {
        // Mobile Sub Menu
        const subMenuBtn = document.querySelector('.subMenuBtn');
        const subMenuIcon = document.querySelector('.subMenuIcon');
        const subMenu = document.querySelector('.subMenu');

        subMenuBtn.addEventListener('click', () => {
            if (subMenu.classList.contains('open')) {
                subMenu.classList.remove('open');
                subMenu.classList.add('close');
                subMenuBtn.classList.remove('open');
            } else {
                subMenu.classList.remove('close');
                subMenu.classList.add('open');
                subMenuBtn.classList.add('open');
            }
        });

        // Submenu listen to enter-click
        subMenuBtn.addEventListener('keyup', function (e) {
            if (e.keyCode === 13) {
                if (subMenu.classList.contains('open')) {
                    subMenu.classList.remove('open');
                    subMenu.classList.add('close');
                    subMenuBtn.classList.remove('open');
                } else {
                    subMenu.classList.remove('close');
                    subMenu.classList.add('open');
                    subMenuBtn.classList.add('open');
                }
            }
        });
    }


    //handles clicks and keydowns on the link
    function navigateLink(evt) {
        if (evt.type == "click" ||
            evt.keyCode == sap.ui.keycodes.SPACE ||
            evt.keyCode == sap.ui.keycodes.ENTER) {
            var ref = evt.target != null ? evt.target : evt.srcElement;
            if (ref) window.open(ref.innerText, "_blank");
        }
    }

    /*
    *
    *
    * JS for the statistics section, should be moved to an own file.
    *
    *
    */

    const statisticsContainer = document.querySelector('[data-statistics-container]');

    // Checks if there is a container for satistics
    if (statisticsContainer != undefined) {
        let statisticsData;
        let numberOfStatisticsGroups;
        const dataListDisclaimerText = "Skillnaden från Sverige är inte statistiskt säkerställd";

        const baseUrl = window.location.protocol + "//" + window.location.host + "/";
        const apiUrl = document.querySelector("[data-statistics-api-url]").getAttribute('data-statistics-api-url');
        const completeUrl = baseUrl + apiUrl;

        const showStatisticsButton = document.querySelector("[data-show-statistics-button]");
        const statisticsContainerId = statisticsContainer.getAttribute('id');
        showStatisticsButton.setAttribute('href', '#' + statisticsContainerId);

        showStatisticsButton.addEventListener('click', function (e) {
            e.preventDefault();
            let element = statisticsContainer;

            if (element != undefined) {
                const headerOffset = 25;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - headerOffset;
                // const hash = statisticsContainerId;
                $('html, body').animate({
                    scrollTop: offsetPosition
                }, function () {
                    // window.location.hash = hash;
                });
            }
        });

        var getJSON = function (url) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);

            xhr.onload = function () {
                var status = xhr.status;
                if (status == 200) {
                    const response = JSON.parse(xhr.responseText);
                    statisticsData = response.Result;
                    numberOfStatisticsGroups = statisticsData.length;
                    displayStatisticsGroups(numberOfStatisticsGroups);
                } else {
                    console.error(status);
                }
            };
            xhr.send();
        };

        getJSON(completeUrl);

        // Displays all Statistics Sections in the Statistics Container
        function displayStatisticsGroups(numberOfStatisticsGroups) {
            for (let i = 0; i < numberOfStatisticsGroups; i++) {
                const statisticsGroup = createStatisticsGroup(i);
                statisticsContainer.appendChild(statisticsGroup);
                addInitialStatisticsData(i);
            }
            checkIsSectionInView('.statistics-group__section', 'visible');

            //Manual anchor jumping for when Statistics are rendered
            let hash = window.location.hash;
            if (hash) {
                scrollToId(hash);
            }
        };

        // Creates and returns a Statistics Group.
        function createStatisticsGroup(groupIndex) {
            const groupElement = document.createElement('section');
            groupElement.setAttribute('class', 'statistics-group');
            groupElement.setAttribute('id', statisticsData[groupIndex].AnchorJumpId);

            const groupHeading = document.createElement('h2');
            const groupChapterName = statisticsData[groupIndex].StatisticsGroupChapterName;
            if (groupChapterName != undefined && groupChapterName.length != 0) {
                groupHeading.innerHTML = "<span>" + groupChapterName + "</span>" + statisticsData[groupIndex].StatisticsGroupHeading;
            } else {
                groupHeading.innerText = statisticsData[groupIndex].StatisticsGroupHeading;
            }
            groupHeading.setAttribute('class', 'statistics-group__heading');
            groupElement.appendChild(groupHeading);

            if (statisticsData[groupIndex].StatisticsGroupDescription.length != 0) {
                const groupDescriptionWholeContent = statisticsData[groupIndex].StatisticsGroupDescription;
                let groupDescriptionWholeContentTrimmed = groupDescriptionWholeContent;
                var groupDescriptionLength = groupDescriptionWholeContent.length;
                var groupDescriptionMaxLength = 140;

                if (groupDescriptionLength > groupDescriptionMaxLength) {
                    //trim the string to the maximum length
                    groupDescriptionWholeContentTrimmed = groupDescriptionWholeContent.substr(0, groupDescriptionMaxLength) + "...";
                    //re-trim if we are in the middle of a word
                    groupDescriptionWholeContentTrimmed = groupDescriptionWholeContentTrimmed.substr(0, Math.min(groupDescriptionWholeContentTrimmed.length, groupDescriptionWholeContentTrimmed.lastIndexOf(" "))) + "...";
                }

                const groupDescription = document.createElement('p');
                groupDescription.setAttribute('class', 'statistics-group__description clearfix');

                const groupDescriptionContent = document.createElement('span');
                groupDescriptionContent.innerText = groupDescriptionWholeContentTrimmed;

                groupDescription.appendChild(groupDescriptionContent);

                const groupExpandBtn = document.createElement('button');
                groupExpandBtn.setAttribute('class', 'statistics-group__expand-button');
                groupExpandBtn.innerHTML = "<span class='only-for-screen-readers'>Läs mer</span>";
                groupExpandBtn.addEventListener('click', function (e) {
                    const targetClassList = e.target.classList;
                    const currentGroupDescriptionContent = e.target.parentElement.querySelector("span");
                    targetClassList.toggle('active');
                    if (targetClassList.contains('active')) {
                        currentGroupDescriptionContent.innerText = groupDescriptionWholeContent;
                    } else {
                        currentGroupDescriptionContent.innerText = groupDescriptionWholeContentTrimmed;
                    }
                });

                if (groupDescriptionLength > groupDescriptionMaxLength) {
                    groupDescription.appendChild(groupExpandBtn);
                }
                groupElement.appendChild(groupDescription);
            }

            const sections = createSections(groupIndex);
            groupElement.appendChild(sections);

            return groupElement;
        };

        // Creates and returns all sections for a Statistics Group.
        function createSections(groupIndex) {
            const sectionContainer = document.createElement('div');

            for (let i = 0; i < statisticsData[groupIndex].StatisticsGroupSections.length; i++) {
                (() => {
                    let section = undefined;
                    let sectionHeading = undefined;
                    let sectionExpandBtn = undefined;
                    let sectionAdditionalInformation = undefined;
                    let sectionDescription = undefined;
                    let sectionTrend = undefined;
                    let sectionYearSelectContainer = undefined;
                    let sectionYearSelectFlexContainer = undefined;
                    let sectionYearSelectWrapper = undefined;
                    let sectionYearSelect = undefined;
                    let sectionYearSelectLabel = undefined;
                    let sectionYearSelectButton = undefined;

                    const currentSection = statisticsData[groupIndex].StatisticsGroupSections[i];
                    const currentSectionIndex = i;
                    const currentSectionYears = currentSection.Years;
                    const diagram = createDiagram(groupIndex, currentSectionIndex);
                    const dataList = createDataList(groupIndex, currentSectionIndex);
                    let sectionYearSelectOption = undefined;

                    section = document.createElement('section');
                    section.setAttribute('class', 'statistics-group__section');
                    section.setAttribute('data-group-index', groupIndex);
                    section.setAttribute('data-section-index', currentSectionIndex);
                    section.setAttribute('id', statisticsData[groupIndex].StatisticsGroupSections[i].AnchorJumpId);

                    sectionHeading = document.createElement('h3');
                    sectionHeading.setAttribute('class', 'statistics-group__section__heading');
                    sectionHeading.innerText = currentSection.SectionHeading;

                    sectionExpandBtn = document.createElement('button');
                    sectionExpandBtn.setAttribute('class', 'statistics-group__section__expand-button');
                    sectionExpandBtn.innerHTML = "<span class='only-for-screen-readers'>Läs mer</span>";
                    sectionExpandBtn.addEventListener('click', function (e) {
                        e.target.classList.toggle('active');
                        e.target.nextElementSibling.classList.toggle('visible');
                        e.target.nextElementSibling.classList.toggle('nospeech');
                        animateDatalistCountries(groupIndex, currentSectionIndex, 100);
                    });

                    sectionAdditionalInformation = document.createElement('div');
                    sectionAdditionalInformation.setAttribute('class', 'statistics-group__section__additional-information nospeech');

                    if (currentSection.SectionDescription.length != 0) {
                        sectionDescription = document.createElement('p');
                        sectionDescription.setAttribute('class', 'statistics-group__section__description');
                        sectionDescription.innerText = currentSection.SectionDescription;
                        sectionAdditionalInformation.appendChild(sectionDescription);
                    }

                    sectionTrend = document.createElement('div');
                    sectionTrend.setAttribute('class', 'statistics-group__section__trend');

                    // Render a year select list if there is data for more than one year.
                    if (currentSectionYears.length > 1) {
                        sectionYearSelectContainer = document.createElement('div');
                        sectionYearSelectContainer.setAttribute('class', 'statistics-group__section__year-select');

                        sectionYearSelectLabel = document.createElement('label');
                        sectionYearSelectLabel.innerText = "Statistik f\xF6r \xE5r:"
                        sectionYearSelectLabel.setAttribute('for', 'statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-year-select');

                        sectionYearSelectFlexContainer = document.createElement('div');
                        sectionYearSelectFlexContainer.setAttribute('class', 'statistics-group__section__year-select__flex-container');

                        sectionYearSelectWrapper = document.createElement('div');
                        sectionYearSelectWrapper.setAttribute('class', 'select');
                        sectionYearSelect = document.createElement('select');
                        sectionYearSelect.setAttribute('id', 'statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-year-select');
                        sectionYearSelectWrapper.appendChild(sectionYearSelect);

                        for (let i = 0; i < currentSectionYears.length; i++) {
                            const currentSectionYear = currentSectionYears[i];
                            sectionYearSelectOption = document.createElement('option');
                            sectionYearSelectOption.value = i;
                            sectionYearSelectOption.innerText = currentSectionYear.Name;
                            sectionYearSelect.appendChild(sectionYearSelectOption);
                        }

                        sectionYearSelectButton = document.createElement('button');
                        sectionYearSelectButton.innerText = "V\xE4lj";
                        sectionYearSelectButton.addEventListener('click', function (e) {
                            const currentYearSelect = e.target.previousElementSibling.getElementsByTagName("select")[0];
                            const selectedYear = currentYearSelect.options[currentYearSelect.selectedIndex].value;
                            updateDiagram(currentSection, currentSectionIndex, groupIndex, selectedYear);
                            animateDiagramCountries(groupIndex, currentSectionIndex, 10, 500);
                            updateDataList(currentSection, currentSectionIndex, groupIndex, selectedYear);
                            animateDatalistCountries(groupIndex, currentSectionIndex, 100);
                        });

                        sectionYearSelectContainer.appendChild(sectionYearSelectLabel);
                        sectionYearSelectFlexContainer.appendChild(sectionYearSelectWrapper);
                        sectionYearSelectFlexContainer.appendChild(sectionYearSelectButton);
                        sectionYearSelectContainer.appendChild(sectionYearSelectFlexContainer);
                    }

                    section.appendChild(sectionHeading);
                    section.appendChild(diagram);
                    section.appendChild(sectionExpandBtn);

                    sectionAdditionalInformation.appendChild(dataList);
                    sectionAdditionalInformation.appendChild(sectionTrend);

                    if (currentSectionYears.length > 1) {
                        sectionAdditionalInformation.appendChild(sectionYearSelectContainer);
                    }

                    section.appendChild(sectionAdditionalInformation);

                    sectionContainer.appendChild(section);
                })();

            }
            ;
            return sectionContainer;
        };

        function addInitialStatisticsData(groupIndex) {
            for (let i = 0; i < statisticsData[groupIndex].StatisticsGroupSections.length; i++) {
                const currentSection = statisticsData[groupIndex].StatisticsGroupSections[i];
                const currentSectionIndex = i;
                updateDiagram(currentSection, currentSectionIndex, groupIndex, 0);
                updateDataList(currentSection, currentSectionIndex, groupIndex, 0);
            }
            ;
        };

        function createDiagram(groupIndex, currentSectionIndex) {
            const diagramElement = document.createElement('div');
            diagramElement.setAttribute('class', 'statistics-group__section__diagram');

            const diagramLine = document.createElement('div');
            diagramLine.setAttribute('class', 'statistics-group__section__diagram__line');

            const diagramStartPoint = document.createElement('div');
            diagramStartPoint.setAttribute('class', 'statistics-group__section__diagram__startpoint');
            diagramStartPoint.setAttribute('aria-hidden', 'true');

            const diagramEndPoint = document.createElement('div');
            diagramEndPoint.setAttribute('class', 'statistics-group__section__diagram__endpoint');
            diagramEndPoint.setAttribute('aria-hidden', 'true');

            const diagramMedianDescription = document.createElement('div');
            diagramMedianDescription.setAttribute('class', 'statistics-group__section__diagram__median-description');
            diagramMedianDescription.setAttribute('data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-diagram-median-description', '');

            const diagramTrendDirection = document.createElement('div');
            diagramTrendDirection.setAttribute('class', DIAGRAM_TREND_DIRECTION_CLASS);
            diagramTrendDirection.setAttribute('data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-diagram-trend-direction', '');

            const diagramData = document.createElement('div');
            diagramData.setAttribute('data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-diagram', '');
            diagramData.setAttribute('class', 'statistics-group__section__diagram__data-container');

            diagramElement.appendChild(diagramLine);
            diagramElement.appendChild(diagramStartPoint);
            diagramElement.appendChild(diagramEndPoint);
            diagramElement.appendChild(diagramData);
            diagramElement.appendChild(diagramMedianDescription);
            diagramElement.appendChild(diagramTrendDirection);

            return diagramElement;
        };

        function updateDiagram(currentSection, currentSectionIndex, groupIndex, diagramCurrentYearIndex) {
            let diagramChosenYearIndex = diagramCurrentYearIndex;
            let diagramChosenYearData = currentSection.Years[diagramChosenYearIndex];
            let diagramChosenYearCountries = diagramChosenYearData.Countries;
            let diagramChosenYearMedianPercent = diagramChosenYearData.MedianPercent;
            let diagramChosenYearTrendDirection = diagramChosenYearData.TrendDirectionPercentage;

            const currentDiagramData = document.querySelector('[data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-diagram]');
            const currentDiagramMedianDescription = document.querySelector('[data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-diagram-median-description]');
            currentDiagramData.innerHTML = '';
            currentDiagramMedianDescription.innerText = "Medel: " + diagramChosenYearMedianPercent + "%";


            let currentDiagramTrendDirection = document.querySelector('[data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-diagram-trend-direction]');
            if (currentDiagramTrendDirection) {
                currentDiagramTrendDirection.setAttribute('class', DIAGRAM_TREND_DIRECTION_CLASS);
            }


            if (diagramChosenYearTrendDirection) {
                let trendDirectionClass = (diagramChosenYearTrendDirection == 0 || diagramChosenYearTrendDirection == UNCHANGED)
                    ? 'statistics-group__section__diagram__trend-direction--unchanged'
                    : (diagramChosenYearTrendDirection > 0 ? 'statistics-group__section__diagram__trend-direction--increasing' : 'statistics-group__section__diagram__trend-direction--decreasing');
                if (currentDiagramTrendDirection) {
                    currentDiagramTrendDirection.classList.add(trendDirectionClass);
                    let trendDirectionText = '<span>Sverige</span>';
                    if (diagramChosenYearTrendDirection === UNCHANGED) {
                        trendDirectionText += diagramChosenYearTrendDirection;
                        currentDiagramTrendDirection.innerHTML = trendDirectionText;
                    } else {
                        trendDirectionText += diagramChosenYearTrendDirection > 0 ? '+' + diagramChosenYearTrendDirection : diagramChosenYearTrendDirection;
                        currentDiagramTrendDirection.innerHTML = trendDirectionText + ' procentenheter';
                    }

                }
            } else {
                if (currentDiagramTrendDirection) {
                    currentDiagramTrendDirection.innerHTML = '';
                }
            }

            const medianIndicator = document.createElement('div');
            medianIndicator.setAttribute('class', 'statistics-group__section__diagram__median-indicator');
            medianIndicator.style.width = diagramChosenYearMedianPercent + "%";
            const medianIndicatorInnerDiv = document.createElement('div');
            medianIndicator.appendChild(medianIndicatorInnerDiv);
            currentDiagramData.appendChild(medianIndicator);
            let diagramCountry = undefined;
            let diagramCountryIndicator = undefined;
            let diagramCountryIndicatorBackground = undefined;

            for (let i = 0; i < diagramChosenYearCountries.length; i++) {
                const currentCountry = diagramChosenYearCountries[i];
                diagramCountry = document.createElement('div');

                diagramCountryIndicator = document.createElement('div');
                diagramCountryIndicator.setAttribute('class', 'statistics-group__section__diagram__country__indicator');
                diagramCountry.appendChild(diagramCountryIndicator);

                diagramCountryIndicatorBackground = document.createElement('div');
                diagramCountryIndicatorBackground.setAttribute('class', 'statistics-group__section__diagram__country__indicator-background');
                diagramCountry.appendChild(diagramCountryIndicatorBackground);

                if (currentCountry.Primary) {
                    diagramCountry.setAttribute('class', 'statistics-group__section__diagram__country statistics-group__section__diagram__country--primary');
                    diagramCountry.setAttribute('data-diagram-country-primary', '');
                } else {
                    diagramCountry.setAttribute('class', 'statistics-group__section__diagram__country');
                }

                diagramCountry.setAttribute('data-diagram-country', '');
                diagramCountry.setAttribute('data-diagram-country-width', currentCountry.Percent);

                currentDiagramData.appendChild(diagramCountry);
            }
            ;
        };

        function createDataList(groupIndex, currentSectionIndex) {
            const dataListContainer = document.createElement('div');
            dataListContainer.setAttribute('class', 'statistics-group__section__data-list');

            const dataListHeading = document.createElement('h3');
            dataListHeading.setAttribute('class', 'statistics-group__section__data-list__heading');
            dataListHeading.innerText = "Alla länder:";
            dataListContainer.appendChild(dataListHeading);

            const dataList = document.createElement('ul');
            dataList.setAttribute('data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-data-list', '');

            const dataListDisclaimer = document.createElement('p');
            dataListDisclaimer.setAttribute('class', 'statistics-group__section__data-list__disclaimer nospeech');
            dataListDisclaimer.setAttribute('data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-data-list-disclaimer', '');
            dataListDisclaimer.innerText = dataListDisclaimerText;
            dataListDisclaimer.setAttribute('aria-hidden', 'true');

            let dataListTrend = document.createElement('div');
            dataListTrend.setAttribute('class', 'statistics-group__section__data-list__trend');
            dataListTrend.setAttribute('data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-data-list-trend', '');

            dataListContainer.appendChild(dataList);
            dataListContainer.appendChild(dataListDisclaimer);
            dataListContainer.appendChild(dataListTrend);
            return dataListContainer;
        };

        function updateDataList(currentSection, currentSectionIndex, groupIndex, dataListCurrentYearIndex) {
            let dataListChosenYearIndex = dataListCurrentYearIndex;
            let diagramChosenYearData = currentSection.Years[dataListChosenYearIndex];
            let dataListChosenYearCountries = diagramChosenYearData.Countries;
            let diagramChosenYearTrendDirection = diagramChosenYearData.TrendDirectionPercentage;
            const currentDataList = document.querySelector('[data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-data-list]');
            currentDataList.innerHTML = '';
            const currentDataListDisclaimer = document.querySelector('[data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-data-list-disclaimer]');
            currentDataListDisclaimer.classList.remove('visible');
            currentDataListDisclaimer.classList.add('nospeech');
            const currentDataListTrend = document.querySelector('[data-statistics-group-' + groupIndex + '-section-' + currentSectionIndex + '-data-list-trend]');
            currentDataListTrend.innerHTML = '';
            let dataListItem = undefined;
            let dataListItemPercentIndicator = undefined;

            for (let i = 0; i < dataListChosenYearCountries.length; i++) {
                const currentCountry = dataListChosenYearCountries[i];
                dataListItem = document.createElement('li');
                dataListItem.innerHTML = currentCountry.Name + "<span class='statistics-group__section__data-list__percent'>" + currentCountry.Percent + "%</span>";
                dataListItemPercentIndicator = document.createElement('span');
                dataListItemPercentIndicator.setAttribute('class', 'statistics-group__section__data-list__percent-indicator');
                dataListItemPercentIndicator.setAttribute('data-percent-indicator', '');
                dataListItemPercentIndicator.setAttribute('data-percent-indicator-width', currentCountry.Percent);
                dataListItem.appendChild(dataListItemPercentIndicator);

                if (!currentCountry.StatisticallyReliable) {
                    dataListItem.setAttribute('class', 'not-statistically-reliable');
                    dataListItem.innerHTML = currentCountry.Name + "<span class='statistics-group__section__data-list__percent'>" + currentCountry.Percent + "%</span>" + "<span class='only-for-screen-readers'>" + dataListDisclaimerText + "</span>";
                    dataListItem.appendChild(dataListItemPercentIndicator);

                    if (!currentDataListDisclaimer.classList.contains('visible')) {
                        currentDataListDisclaimer.classList.add('visible');
                        currentDataListDisclaimer.classList.remove('nospeech');
                    }
                }
                if (currentCountry.Primary) {
                    dataListItem.classList.add('primary');
                }
                currentDataList.appendChild(dataListItem);
            }
            ;


            // Displays a text about the current trend if there is data available
            if (diagramChosenYearData.TrendDescription.length != 0) {
                let modifier = '';
                if (diagramChosenYearTrendDirection) {
                    if (diagramChosenYearTrendDirection === UNCHANGED) {
                        modifier = 'statistics-group__section__data-list__trend__heading--unchanged';
                    } else if (diagramChosenYearTrendDirection == 0) {
                        modifier = 'statistics-group__section__data-list__trend__heading--unchanged';
                    } else if (diagramChosenYearTrendDirection < 0) {
                        modifier = 'statistics-group__section__data-list__trend__heading--decreasing';
                    } else if (diagramChosenYearTrendDirection > 0) {
                        modifier = 'statistics-group__section__data-list__trend__heading--increasing';
                    }
                }
                currentDataListTrend.innerHTML = "<h3 class='statistics-group__section__data-list__trend__heading statistics-group__section__data-list__trend__heading " + modifier + "'>Trend</h3><p>" + diagramChosenYearData.TrendDescription + "</p>";
            }
        }

        window.addEventListener('scroll', function (e) {
            checkIsSectionInView('.statistics-group__section', 'visible');
        });

        window.addEventListener('resize', function (e) {
            checkIsSectionInView('.statistics-group__section', 'visible');
        });

        function checkIsSectionInView(targetClass, activeClass) {
            const sections = document.querySelectorAll(targetClass);
            const sectionsLength = sections.length;
            const windowHeight = window.innerHeight;
            const windowTop = window.pageYOffset;
            const windowBottom = windowTop + windowHeight;
            for (let i = 0; i < sectionsLength; i++) {
                const sectionHeight = sections[i].offsetHeight;
                const sectionTop = sections[i].offsetTop;
                const sectionBottom = sectionTop + sectionHeight;
                if ((windowBottom >= sectionTop && windowTop <= sectionBottom) && !sections[i].classList.contains('visible')) {
                    const currentGroupIndex = sections[i].getAttribute('data-group-index');
                    const currentSectionIndex = sections[i].getAttribute('data-section-index');
                    animateDiagramCountries(currentGroupIndex, currentSectionIndex, 10, 500);
                    sections[i].classList.add(activeClass);
                }
            }
            ;
        };

        function animateDiagramCountries(currentGroupIndex, currentSectionIndex, delay, transitionDuration) {
            const currentDiagram = document.querySelector("[data-statistics-group-" + currentGroupIndex + "-section-" + currentSectionIndex + "-diagram]");
            const currentDiagramCountries = currentDiagram.querySelectorAll("[data-diagram-country]");
            const currentDiagramCountriesLength = currentDiagramCountries.length;

            for (let i = 0; i < currentDiagramCountriesLength; i++) {
                const currentDiagramFinalWidth = currentDiagramCountries[i].getAttribute('data-diagram-country-width');
                currentDiagramCountries[i].style.width = '0%';
                if (currentDiagramCountries[i].hasAttribute('data-diagram-country-primary')) {
                    setTimeout(function () {
                        currentDiagramCountries[i].classList.add('visible');
                        currentDiagramCountries[i].style.width = currentDiagramFinalWidth + '%';
                    }, ((currentDiagramCountriesLength - 1) * delay + transitionDuration));
                } else {
                    setTimeout(function () {
                        currentDiagramCountries[i].classList.add('visible');
                        currentDiagramCountries[i].style.width = currentDiagramFinalWidth + '%';
                    }, ((i + 1) * delay));
                }
            }
        };

        function animateDatalistCountries(currentGroupIndex, currentSectionIndex, delay) {
            console.log('groupindex', currentGroupIndex);
            console.log('sectionindex', currentSectionIndex);
            const currentDatalist = document.querySelector("[data-statistics-group-" + currentGroupIndex + "-section-" + currentSectionIndex + "-data-list]");
            const currentDatalistPercentIndicators = currentDatalist.querySelectorAll("[data-percent-indicator]");
            const currentDatalistPercentIndicatorsLength = currentDatalistPercentIndicators.length;

            for (let i = 0; i < currentDatalistPercentIndicatorsLength; i++) {
                currentDatalistPercentIndicators[i].style.width = '0%';
                const currentDatalistPercentIndicatorFinalWidth = currentDatalistPercentIndicators[i].getAttribute('data-percent-indicator-width');
                setTimeout(function () {
                    console.log(currentDatalistPercentIndicators[i]);
                    currentDatalistPercentIndicators[i].style.width = currentDatalistPercentIndicatorFinalWidth + '%';
                }, ((i + 1) * delay));
            }
        };
    }
    ;

    function scrollToId(id) {
        let $element = $(id);
        if ($element.length > 0) {
            $('html, body').animate({
                scrollTop: $element.offset().top - 20
            }, 0);
        }
    }

    window.addEventListener('DOMContentLoaded', function (e) {
        toggleAccordion();
    });

    function toggleAccordion() {


        const accordionItems = document.querySelectorAll('.accordionItem');

        accordionItems.forEach(function (item) {
            item.addEventListener('click', function () {
                item.classList.toggle('active');

            });

        });
        /*
                const accordion = document.querySelector(".accordion");

                accordion.addEventListener("click", (e) => {
                    const activePanel = e.target.closest(".accordionPanel");
                    if (!activePanel) return;
                    toggleAccordion(activePanel);
                });

                function toggleAccordion(panelToActivate) {
                    const activeButton = panelToActivate.querySelector("button");
                    const activePanel = panelToActivate.querySelector(".accordionContent");
                    const activePanelIsOpened = activeButton.getAttribute("aria-expanded");

                    if (activePanelIsOpened === "true") {
                        panelToActivate
                            .querySelector("button")
                            .setAttribute("aria-expanded", false);

                        panelToActivate
                            .querySelector(".accordionContent")
                            .setAttribute("aria-hidden", true);
                    } else {
                        panelToActivate.querySelector("button").setAttribute("aria-expanded", true);
                        panelToActivate
                            .querySelector(".accordionContent")
                            .setAttribute("aria-hidden", false);
                    }
                }*/


    };


}());